import { types } from "../types/types";

export const authReducer = (state = {}, action) => {
  switch (action.type) {
    case types.login:
      return {
        ...action.payload,
        token: action.payload.token,
      };

    case types.logout:
      return {
        token: null,
      };

    default:
      return state;
  }
};
